let header = jQuery('.header')

jQuery('.body__before').on('click', function(e) {

    jQuery('.header .hamburger').trigger('click')

})

jQuery('.hamburger').on('click', function (e) {

    e.preventDefault()

    if (jQuery(this).hasClass('is-active')) {
        // jQuery('.drawer').attr('tabindex', '-1')
    } else {
        // jQuery('.drawer').attr('tabindex', '1').focus()
    }

    jQuery('body').toggleClass('is-drawer')
    jQuery('.hamburger').toggleClass('is-active')

    jQuery('.header__right').scrollTop(0)
    console.log(jQuery('.header'));

})

jQuery('.my-search').on('click', function (e) {
    jQuery('body').toggleClass('is-drawer')
    jQuery('.hamburger').toggleClass('is-active')
    jQuery('.drawer__search #drawer_search_input').focus();
})

document.addEventListener('keyup', function(e) {
    var $firstFocusable = jQuery('#header .header__logo');
    var $lastFocusable = jQuery('#header #hamburger-toggle');


    if (e.keyCode == 13 && jQuery('body').hasClass('is-drawer')) {

            // Add a tabindex="-1" attribute to the first focusable element
            $firstFocusable.attr('tabindex', '-1');

            // Add a keydown event listener to the last focusable element
            $lastFocusable.on('keydown', function(e) {

                if (e.key === 'Tab') {
                    if (e.shiftKey) {
                        // If Shift + Tab were pressed, focus the last focusable element
                        $firstFocusable.focus();
                        e.preventDefault();

                    } else {
                        // Otherwise, focus the first focusable element
                        $firstFocusable.focus();
                        e.preventDefault();
                    }
                }
        });

    }else if( !jQuery('body').hasClass('is-drawer') ){
        $lastFocusable.off()
    }

    if(e.keyCode == 27 && jQuery('body').hasClass('is-drawer')){
        $lastFocusable.off()

        jQuery('body').toggleClass('is-drawer')
        jQuery('.hamburger').toggleClass('is-active')
    }
});

jQuery('.drawer__nav .toggle').on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        parentEl = thisEl.parent()

    if (parentEl.hasClass('open')) {
        parentEl.toggleClass('open').next().slideToggle()
    } else {
        jQuery('.drawer__nav .open').removeClass('open').next().slideToggle()
        parentEl.toggleClass('open').next().slideToggle()
    }

})

var lastScrollTop = 0

jQuery(window).on('scroll', function () {
    let scrollTop = jQuery(window).scrollTop()

    if ( scrollTop > 40 ) {
        jQuery('.first-nav__holder').css( { 'visibility' : 'hidden' } )
        jQuery('.header').addClass( 'header--white' )
    } else {
        jQuery('.first-nav__holder').css( { 'visibility' : 'visible' } )
        jQuery('.header').removeClass( 'header--white' )
    }

    if( lastScrollTop > scrollTop ) {
        jQuery('.first-nav__holder').css( { 'visibility' : 'visible' } )
        jQuery('.first-nav__holder').addClass( 'first-nav__holder--white' )
    }

    if( scrollTop > lastScrollTop || scrollTop <= 40 )
        jQuery('.first-nav__holder').removeClass( 'first-nav__holder--white' )

    lastScrollTop = scrollTop
})



//Close drawer on keyboard tabbing, if it goes to .home or .header (meaning it is outside .drawer)
// jQuery('.header, .home').focusin(function() {
//     let drawer = document.getElementById("drawer");
//     if(!drawer.contains(document.activeElement) && jQuery('body').hasClass('is-drawer')){
//                 if (jQuery('.hamburger-toggle .hamburger').hasClass('is-active'))
//                     jQuery('.drawer').attr('tabindex', '-1')
//                 else
//                     jQuery('.drawer').attr('tabindex', '1').focus()
//
//                 jQuery('body').toggleClass('is-drawer')
//                 jQuery('.hamburger').toggleClass('is-active')
//
//
//     }
// })

jQuery(document).ready(function(e) {

    if(jQuery('.sticky-navigation').length > 0){

        var lastScrollTop = 0;

        var headerHeight = jQuery('.header').outerHeight();
        var stickyNav = jQuery('.sticky-navigation');
        var stickyNavHeight = jQuery('.sticky-navigation').outerHeight();
        var stickyNavOffset = jQuery('.sticky-navigation').offset().top;

        var bodyHeight = jQuery('body').height();

        stickyNav.css( "top", headerHeight );

        jQuery(window).scroll(function() {

            var headerHeight = jQuery('.header').outerHeight();
            var stickyNav = jQuery('.sticky-navigation');
            var stickyNavHeight = jQuery('.sticky-navigation').outerHeight();

            var scrollTop = jQuery(this).scrollTop() - 2*stickyNavHeight;

            if(scrollTop  < lastScrollTop) {
                ///this is up
               if(lastScrollTop  -  scrollTop + stickyNavHeight > 1){
                   stickyNav.addClass('show');
               }

            } else {
               ///this is down
               if(scrollTop > headerHeight +  stickyNavHeight + stickyNavHeight){
                   stickyNav.removeClass('show');
               }
            }

            lastScrollTop = scrollTop;
        })
    }
})
